import { reportMaintenance } from "./app-status";
export class RoomRequestError extends Error {
  status: number;
  limit?: number;
  constructor(message: string, status: number, limit?: number) {
    super(message);
    this.status = status;
    this.limit = limit;
  }
}
export function authHeaders(): Record<string, string> {
  const token = sessionStorage.getItem("live-room-development-session");
  return token ? { Authorization: `Bearer ${token}` } : {};
}
export async function roomRequest<T = unknown>(
  path: string,
  options: RequestInit = {},
): Promise<T> {
  const response = await fetch(path, {
    credentials: "same-origin",
    ...options,
    headers: {
      ...authHeaders(),
      ...(options.body ? { "Content-Type": "application/json" } : {}),
      ...options.headers,
    },
  });
  // A proxy error page is not JSON, so fall back to an empty body.
  const body = await response.json().catch(() => ({}));
  if (!response.ok) {
    if (body.error === "maintenance") reportMaintenance();
    throw new RoomRequestError(
      body.error || "room-request-failed",
      response.status,
      Number.isInteger(body.limit) && body.limit > 0 ? body.limit : undefined,
    );
  }
  return body;
}
